import { EHR_TOKEN_EXPIRATION_DATE, useStorage } from '@/libs/storage'

const useExpiration = () => {
  const { setItem, getItem, removeItem } = useStorage(EHR_TOKEN_EXPIRATION_DATE)

  const setExpirationDate = (expirationDate: string) => {
    setItem(new Date(expirationDate).getTime())
  }
  const getExpirationDate = () => {
    return getItem()
  }
  const removeExpirationDate = () => {
    removeItem()
  }

  return {
    setExpirationDate,
    getExpirationDate,
    removeExpirationDate
  }
}

export default useExpiration
